<div class="custom-modal-layout">
  <div class="modal-header">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Adicionar Curso" />
    </div>
    <span class="title">Curso</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()" />
  </div>
  <form [formGroup]="institutionForm" (ngSubmit)="save()">

    <div class="d-flex align-items-center justify-content-end gap-2">
      <p-checkbox formControlName="IsNewCurse" [binary]="true" inputId="ShowNew"></p-checkbox>
      <label for="ShowNew" class="text-lg">Novo Curso</label>
    </div>

    <div class="p-fluid grid" [hidden]="institutionForm.get('IsNewCurse')?.value">
      <div class="field col-12">
        <label for="cursoID">Curso</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="cursoID" class="w-full" [options]="cursos"
          optionLabel="designacao" optionValue="id" placeholder="Seleccione o curso" formControlName="cursoID" />
        <!-- <input type="text" class="w-full" pInputText formControlName="cursoID" placeholder="Nome do curso" /> -->
      </div>

      <!-- <div class="field col-12">
        <label for="valorMensalidade">Valor Mensalidade</label>
        <input type="number" class="w-full" id="valorMensalidade" pInputText formControlName="valorMensalidade"
          placeholder="Valor da mensalidade do curso" />
      </div> -->

      <div class="field col-12">
        <label for="valorMensalidade">Valor Mensalidade</label>
        <p-inputNumber id="valorMensalidade" class="w-full" formControlName="valorMensalidade" mode="currency"
          currency="AOA"
          [currencyDisplay]="'symbol'"
          [minFractionDigits]="2"
          placeholder="Valor da mensalidade"
          ></p-inputNumber>
      </div>

      <!-- <div class="field col-12">
        <label for="areaFormacao">Área de Formação</label>
        <p-select [showClear]="true" appendTo="body" id="areaFormacao" class="w-full" [options]="areaFormacao" optionLabel="designacao" optionValue="id"
          placeholder="Seleccione a Área de Formação" (onChange)="onAreaChange($event)" />
      </div> -->

      <div class="field col-12">
        <label for="instituicaoEnsinoID">Unidade Orgânica</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="instituicaoEnsinoID" class="w-full"
          [options]="unidadeOrganicaOptions" optionLabel="nome" optionValue="id"
          placeholder="Seleccione a unidade orgânica" formControlName="instituicaoEnsinoID"></p-select>
      </div>
    </div>

    <div class="p-fluid grid" [hidden]="!institutionForm.get('IsNewCurse')?.value">
      <div class="field col-12">
        <label for="designacao">Nome do curso</label>
        <input id="designacao" type="text" class="w-full" pInputText formControlName="designacao"
          placeholder="Nome do curso" />
      </div>

      <!-- <div class="field col-6">
        <label for="sigla">Sigla do curso</label>
        <input id="sigla" type="text" class="w-full" pInputText formControlName="sigla" placeholder="Sigla" />
      </div>

      <div class="field col-6">
        <label for="codigo">Código do curso</label>
        <input id="codigo" type="text" class="w-full" pInputText formControlName="codigo"
          placeholder="Código do curso" />
      </div> -->

      <div class="field col-6">
        <label for="areaFormacao">Área de Conhecimento</label>
        <p-select id="areaFormacao" class="w-full" optionLabel="designacao" optionValue="id"
          [options]="areaFormacaoList" placeholder="Seleccione uma Área de Conhecimento"
          formControlName="areaFormacaoID"></p-select>
        <div *ngIf="institutionForm.get('areaFormacaoID')?.invalid && institutionForm.get('areaFormacaoID')?.touched"
          class="error-message">
          Área de Formação do curso é obrigatório
        </div>
      </div>

      <div class="field col-6">
        <label for="categoriaInstituicaoEnsinoID">Categoria do curso</label>
        <p-select id="categoriaInstituicaoEnsinoID" class="w-full" optionLabel="designacao" optionValue="id"
          [options]="categoriaInstituicaoEnsinoList" placeholder="Seleccione a categoria"
          formControlName="categoriaInstituicaoEnsinoID"></p-select>
        <div
          *ngIf="institutionForm.get('categoriaInstituicaoEnsinoID')?.invalid && institutionForm.get('categoriaInstituicaoEnsinoID')?.touched"
          class="error-message">
          Categoria do curso é obrigatório
        </div>
      </div>

      <div class="field col-6">
        <label for="nivelAcademico">Grau Académico</label>
        <p-select id="nivelAcademico" class="w-full" optionLabel="designacao" optionValue="id"
          [options]="nivelAcademicoOptions" placeholder="Seleccione o grau Académico"
          formControlName="nivelAcademico"></p-select>
        <div *ngIf="institutionForm.get('nivelAcademico')?.invalid && institutionForm.get('nivelAcademico')?.touched"
          class="error-message">
          Nivel académico do curso é obrigatório
        </div>
      </div>

      <div class="field col-6">
        <label for="instituicaoEnsinoID">Unidade Orgânica</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="instituicaoEnsinoID" class="w-full"
          [options]="unidadeOrganicaOptions" optionLabel="nome" optionValue="id"
          placeholder="Seleccione a unidade orgânica" formControlName="instituicaoEnsinoID"
          [disabled]="!unidadeOrganicaOptions?.length && unidade"></p-select>
      </div>

      <div class="field col-12">
        <label for="valorMensalidade">Valor Mensalidade</label>
        <p-inputNumber id="valorMensalidade" class="w-full" formControlName="valorMensalidade" mode="currency"
          currency="AOA"
          [currencyDisplay]="'symbol'"
          [minFractionDigits]="2"
          placeholder="Valor da mensalidade"
          ></p-inputNumber>
      </div>



      <!-- <div class="field col-12">
        <label for="programaID">Programa de Formação</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="programaID" class="w-full"
          [options]="programas" optionLabel="designacao" optionValue="id"
          placeholder="Seleccione o programa de formação" formControlName="programaID" />
      </div> -->

    </div>

    <div class="modal-footer">
      <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()"></button>
      <button pButton type="button" label="Adicionar" class="p-button-primary" (click)="save()"></button>
    </div>

  </form>
</div>

<!-- <toast></toast> -->
<p-toast></p-toast>
